import * as React from 'react';

import { FieldProps, getIn } from 'formik';

const styles = require('./InputRadio.scss');

export interface Props extends FieldProps {
    label: string;
    hideErrors?: boolean;
}

export const FormikRadioInput = ({ field, form: { errors, touched }, label, hideErrors, ...props }: FieldProps & Props) => {
    return (
        <div className={styles.className}>
            <div className='nx-radio nx-radio--small'>
                <label className={styles.label}>
                    <input {...field} {...props} type='radio' className={styles.label} />
                    {label}
                </label>
                {
                    /* @ts-ignore */
                    !hideErrors && getIn(errors, field.name) && getIn(touched, name) && getIn(errors, field.name) && (
                        <div className={styles.error}>{getIn(errors, field.name)}</div>
                    )
                }
            </div>
        </div>
    );
};

export default FormikRadioInput;
